/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Magnified_Image_AltInputs */



/**
* | output |
* | --- |
* | "Magnified Subtitle Preview" |
*
* @param {Video_Export_Magnified_Image_AltInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_magnified_image_alt = /** @type {((inputs?: Video_Export_Magnified_Image_AltInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Magnified_Image_AltInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Previsualisation agrandie des sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vergrößerte Untertitelvorschau")
	if (locale === "it") return /** @type {LocalizedString} */ ("Anteprima dei sottotitoli ingrandita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Увеличенный предварительный просмотр субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista previa de subtítulos ampliada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("放大字幕预览")
	if (locale === "ja") return /** @type {LocalizedString} */ ("拡大字幕プレビュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बड़ा करके दिखाया गया उपशीर्षक पूर्वावलोकन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pré-visualização ampliada da legenda")
	return /** @type {LocalizedString} */ ("Magnified Subtitle Preview")
});